var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WorkerBeard50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00897b",
    d: "M29,33l-5,1l-5-1c0,0-11,1.984-11,13h32C40,35.023,29,33,29,33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M24,39l-5-6v-6h10v6L24,39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M35,21c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S35,19.895,35,21 M17,21c0-1.105-0.895-2-2-2 s-2,0.895-2,2s0.895,2,2,2S17,22.105,17,21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M33,15c0-7.637-18-4.973-18,0v7c0,4.973,4.027,9,9,9s9-4.027,9-9V15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M24,6c-6.074,0-10,4.926-10,11v2.285L16,21v-5l12-4l4,4v5l2-1.742V17c0-4.023-1.039-8.016-6-9l-1-2 H24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M27,21c0-0.551,0.449-1,1-1s1,0.449,1,1s-0.449,1-1,1S27,21.551,27,21 M19,21c0,0.551,0.449,1,1,1 s1-0.449,1-1s-0.449-1-1-1S19,20.449,19,21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M30,33.254V42H18v-8.75c-0.945,0.281-2.445,0.824-4,1.793V46h20V35.059 C32.445,34.086,30.945,33.535,30,33.254z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M18,42h-4v-3h4V42z M34,39h-4v3h4V39z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M34,15v-1c0-4.973-4.027-9-9-9h-2c-4.973,0-9,4.027-9,9v1h-2v3h24v-3H34z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d84315",
    d: "M21,4h6v11h-6V4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M32.988,21.469c0,0-0.833,1.803-1.668,2.454c-0.535,0.452-2.143,1.505-3.157,1.054 c-1.25-0.552-2.978-1.003-4.169-1.003l-0.063-0.001c-1.191,0-2.857,0.45-4.106,1.003c-1.015,0.451-2.622-0.601-3.157-1.054 C15.833,23.271,15,21.468,15,21.468s-0.759,9.797,8.993,10.893v0.001C33.745,31.266,32.988,21.469,32.988,21.469z M26.971,28.99 c-1.19,0-1.191-1.504-2.976-1.505v-0.001c-1.787,0-1.787,1.505-2.978,1.505c-1.787,0-0.596-2.006-0.596-2.508 c0-0.501,3.573-1.003,3.573-1.003v0.001c0,0,3.573,0.501,3.573,1.003C27.567,26.983,28.758,28.99,26.971,28.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WorkerBeard50);
export default __webpack_public_path__ + "static/media/icons8-worker-beard-50.aea8284f40cfd28c7c340afa164d8aad.svg";
export { ForwardRef as ReactComponent };